import React, { forwardRef } from "react";
import { ListItem } from "@mui/material";
import { NavLink } from "react-router-dom";

const AppMenuItemComponent = (props) => {
  const { className, onClick, link, children } = props;

  // If link is not set return the orinary ListItem
  if (!link || typeof link !== "string") {
    return (
      <ListItem className={className} children={children} onClick={onClick} />
    );
  }

  // Return a ListItem with a link component
  return (
    <ListItem
      className={className}
      children={children}
      component={forwardRef((props, ref) => (
        <NavLink {...props} />
      ))}
      to={link}
      onClick={onClick}
    />
  );
};

export default AppMenuItemComponent;
